import React from "react";

const testimonials = [
  {
    quote:
      "Cypera Digital delivered a well versed designed website that helped us to elevate our brand identity online. Their team worked with precision and creativity, ensuring our clients found the experience seamless and engaging throughout.",
    name: "Rohan Mehta",
    role: "CEO, Indian Technology Solutions",
    image: "review/review1.jpg",
  },
  {
    quote:
      "Working with Cypera Digital on our digital marketing campaigns was a game-changer. Their data-backed cool strategies and expert team led us to a clear spike in the user engagement, bringing a measurable value to our brand efforts.",
    name: "Sarah Johnson",
    role: "Marketing Manager, American Retail Corp",
    image: "review/review2.jpg",
  },
  {
    quote:
      "Our new e-commerce platform, built by Cypera Digital, streamlined our sales. The team made everything smooth—from product display to payments—giving our customers a premium and hassle-free shopping experience.",
    name: "Ahmed Al-Farsi",
    role: "Founder, Dubai Traders",
    image: "review/review3.jpg",
  },
  {
    quote:
      "Cypera Digital helped scale our social media presence with engaging content and impactful campaigns. Their strategic planning and consistent efforts directly improved our following and brand awareness.",
    name: "Priya Nair",
    role: "Brand Manager, Indian Fashion House",
    image: "review/review4.jpg",
  },
  {
    quote:
      "We trusted Cypera Digital to revamp our outdated website, and they delivered beautifully. The result is a fast, modern, and user-friendly design that’s both functional and aesthetically aligned with our brand.",
    name: "David Smith",
    role: "CEO, American Financial Services",
    image: "review/review5.jpg",
  },
  {
    quote:
      "Thanks to Cypera Digital’s SEO expertise, our website now ranks significantly higher. Their continuous optimization and analytics-driven methods have brought more organic traffic and real business conversions.",
    name: "Arjun Desai",
    role: "Head of Marketing, Indian Startup Hub",
    image: "review/review6.jpg",
  },
];

const TestimonialCard = ({ quote, name, role, image }) => (
  <div className="flex flex-col justify-between bg-white rounded-3xl p-6 shadow-lg w-80 mx-4 flex-shrink-0 h-full min-h-[320px]">
    <p className="text-gray-600 text-base sm:text-lg mb-6 whitespace-normal break-words">

      "{quote}"
    </p>
    <div className="flex items-center mt-auto">
      <img
        src={image}
        alt={name}
        className="w-12 h-12 rounded-full border-2 border-blue-500 flex-shrink-0"
      />
      <div className="ml-4 min-w-0">
        <h4 className="font-bold text-blue-600">{name}</h4>
        <p className="text-gray-500 text-sm overflow-hidden text-ellipsis whitespace-nowrap">
          {role}
        </p>
      </div>
    </div>
  </div>
);

const Testimonials = () => {
  return (
    <div className="bg-blue-800 text-white py-12">
      <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8">
        Don’t take our word for it
      </h2>
      <div className="relative mb-10 flex overflow-hidden">
        {/* Marquee container */}
        <div className="py-2 animate-marquee whitespace-nowrap flex">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard
              key={index}
              quote={testimonial.quote}
              name={testimonial.name}
              role={testimonial.role}
              image={testimonial.image}
            />
          ))}
        </div>
        <div className="py-2 animate-marquee2 whitespace-nowrap absolute top-0 flex">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard
              key={index}
              quote={testimonial.quote}
              name={testimonial.name}
              role={testimonial.role}
              image={testimonial.image}
            />
          ))}
        </div>
      </div>
      <div className="flex justify-center mt-8">
        <button className="p-4 px-8 font-kanit bg-gradient-to-r from-white to-white text-blue-600 hover:text-white hover:from-blue-500 hover:to-blue-500 text-base rounded-full">
          More stories
        </button>
      </div>
    </div>
  );
};

export default Testimonials;
